import { css } from '@emotion/css';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { usesNewPoster } from 'Shared/model/Event';
import { useUrls } from 'Shared/UrlProvider';


const imageStyle = css({
	width: '100%',
	height: '100%',
	objectPosition: 'center',
	objectFit: 'cover'
});


/*
	Posters built with the new builder are shown as the image rendered when the design was last
	saved, rather than being drawn again in the browser. An empty design means the event was never
	built with the new builder, so those events keep the old builder's posters.
*/
export function usesRenderedPoster(event): boolean
{
	return usesNewPoster(event) && (event.posterNEW?.design?.objects?.length ?? 0) > 0;
}

/* Without a rendered image there is nothing to show and the fallback poster has to stand in. */
export function hasRenderedPoster(poster): boolean
{
	return poster?.hash != undefined && poster?.formats?.medium != undefined;
}

/* Only worth showing while the render is both present and up to date. */
export function isCurrentRenderedPoster(poster): boolean
{
	return poster?.isCurrent == true && hasRenderedPoster(poster);
}

/* Takes the poster off the event rather than being handed one, so callers holding a fresher
   render than the document's (see the events list) ask isCurrentRenderedPoster directly. */
export function hasCurrentRenderedPoster(event): boolean
{
	return isCurrentRenderedPoster(event.posterNEW);
}

export function EventPosterImage(P:{event})
{
	const poster = () => P.event.posterNEW;

	const url = () => useUrls().createVenueImageUrl(
		poster().hash, poster(), 'Event-poster', 'medium', useProxyProductionImages());

	return (
		<img class={imageStyle} src={url()} loading='lazy' alt='' />
	);
}
